<template>
  <h1>
    <slot></slot>
  </h1>
</template>

<script>
  export default {}
</script>

<style scoped>
h1 {
  margin-top: 0;
  margin-bottom: var(--margin--small);
  padding: var(--margin--large);
  color: var(--color-main);

  text-align: center;
}

.bow-form-wrapper h1 {
  background-color: var(--color-white--darker);
}
</style>
